import { createSlice } from "@reduxjs/toolkit";
import { returnee_applications } from "../../../types/returnee/returnee_application";

export const returneeApplications = createSlice({
  name: "returnee_applications",
  initialState: {
    value: {
      status: false,
      data: [] as returnee_applications,
    },
  },
  reducers: {
    update_returnee_applications: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload;
    },
    add_returnee_application: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
    },
    remove_returnee_application: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === id
      );
      currentArray.splice(currentIndex, 1);
      state.value.data = currentArray;
    },
    replace_returnee_application: (state, action) => {
      const { id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      currentArray.splice(currentIndex, 1, action?.payload);
      state.value.data = currentArray;
    },
    clear_returnee_applications: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  update_returnee_applications,
  add_returnee_application,
  remove_returnee_application,
  replace_returnee_application,
  clear_returnee_applications,
} = returneeApplications.actions;

export default returneeApplications.reducer;
